var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"buttonDiv"}},[_c('img',{attrs:{"src":require("../assets/google.png")}}),_c('span',[_vm._v("Sign in with Google")])])])
}]

export { render, staticRenderFns }